module.exports = __webpack_public_path__ + "static/konfor-sm-aae2799731b5a785539ddd71a9cf01d9.jpg";